import { render } from "./OriginalDocumentOrderListWidget.vue?vue&type=template&id=ac373ece&ts=true"
import script from "./OriginalDocumentOrderListWidget.ts?vue&type=script&lang=ts&external"
export * from "./OriginalDocumentOrderListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__